<template>
  <div class="layers">
    <h2>Warstwy</h2>
    <draggable :list="layers" @end="handleLayersChange">
        <el-tag @click="handleObjectClick(layer)" type="info" v-for="(layer, index) in layers" :key="index">
            {{ getObjectType(layer) }}
            <span class="actions">
                <i class="fas" :class="{ 'fa-lock': layer.lockMovementX, 'fa-lock-open': !layer.lockMovementX }" @click="handleMovingObject(layer)"></i>
                <i :class="{ 'fas fa-hand-point-up': layer.selectable, 'far fa-hand-point-up': !layer.selectable }" @click="handleSelectionObject(layer)"></i>
                <i class="fas" :class="{ 'fa-eye': !layer.excludeFromSVG, 'fa-eye-slash': layer.excludeFromSVG }" @click="handleToggleVisibilityObject(layer)"></i>
                <i class="fas fa-trash-alt" @click="handleRemoveObject(layer)"></i>
            </span>
        </el-tag>
    </draggable>
  </div>
</template>

<script>
import Editor from '../../classes/Editor'
import Draggable from 'vuedraggable'

export default {
    data() {
      return {
          layers: [],
          sortLayers: []
      };
    },
    mounted() {
        // Load layers on load
        this.layers = Editor.getObjects()

        // Update layers on canvas rerender
        Editor.addCallback('after:render', () => this.layers = Editor.getObjects())
    },
    methods: {
        handleObjectClick(object) {
            Editor.canvas.setActiveObject(object)
            Editor.canvas.renderAll()
        },
        handleLayersChange() {
            this.layers.reverse().forEach((object, index) => object.moveTo(index))
        },
        getObjectType(object) {
            switch (object.type) {
                case 'image':
                    return object.id === 'slot' ? 'Slot na zdjęcie' : 'Zdjęcie';
                case 'textbox':
                    return object.id == 'personalizedField' ? 'Pole personalizowane' : `Tekst (${object.text.substring(0, 25)}...)`;
                case 'group':
                    return object.id == 'qrcode' ? 'Kod QR' : ''
                case 'rect':
                    switch(object.id) {
                        case 'cuttingLine':
                            return 'Linia cięcia';
                        case 'safetyMargin':
                            return 'Bezpieczny zadruk';
                        default:
                            return '';
                    }
                default:
                    return '';
            }
        },
        handleMovingObject(object) {
            object.lockMovementX = !object.lockMovementX
            object.lockMovementY = !object.lockMovementY
        },
        handleSelectionObject(object) {
            object.selectable = !object.selectable
            object.evented = object.selectable
            Editor.canvas.fire('object:modified');
            // Editor.setStyleForActiveObject('selectable', !object.selectable, false, false)
            // Editor.setStyleForActiveObject('evented', object.selectable, false, false)
        },
        handleToggleVisibilityObject(object) {
            object.excludeFromSVG = !object.excludeFromSVG
        },
        handleRemoveObject(object) {
            this.$confirm('Czy na pewno usunąć ten element?', 'Uwaga!', {
                type: 'warning',
                confirmButtonText: 'Tak',
            }).then(() => Editor.canvas.remove(object))
        },
    },
    components: {
        Draggable
    }
}
</script>

<style lang="less">
    .el-tag {
        color: black;
        display: flex;
        cursor: pointer;
    }
    .el-tag + .el-tag {
        margin-top: 7px;
    }
  .actions {
      margin-left: auto;
      i {
          color: #5e5e5e;
          cursor: pointer;

          + i {
              margin-left: 5px;
          }
      }
  }
</style>